.#{$namespace}-tab-pane {
	width: 100%;
}
